var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubscriptions = function SvgSubscriptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#363840",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.96 12.394a8.5 8.5 0 0 1-15.815 3.357l-.25-.432m-.842-4.71a8.5 8.5 0 0 1 15.815-3.357l.25.432M3 17.567l.732-2.732 2.732.732M16.55 7.435l2.732.732.732-2.732m-8.506 1.566v4.5l2.5 1.5"
  })));
};
export default SvgSubscriptions;